/* eslint-disable */

/** unique or primary key constraints on table "argo.work_order_activity_kind" */
export enum ArgoWorkOrderActivityKindConstraint {
  /** unique or primary key constraint on columns "kind" */
  WorkOrderActivityKindPkey = 'work_order_activity_kind_pkey'
}

export enum ArgoWorkOrderActivityKindEnum {
  /** Work Order was changed */
  Config = 'config',
  /** Work Order material was changed */
  Material = 'material',
  /** Work Order status was changed */
  Status = 'status'
}

/** select columns of table "argo.work_order_activity_kind" */
export enum ArgoWorkOrderActivityKindSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Kind = 'kind'
}

/** update columns of table "argo.work_order_activity_kind" */
export enum ArgoWorkOrderActivityKindUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Kind = 'kind'
}

